import { Box, Flex } from '@rebass/grid';
import { breakpoints, css, styled } from 'styles';
import { AnchorButton } from 'styles/button';

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const Container = styled(Flex)`
  background: #151515;
  border-radius: 4px;
  padding: 15px;
  flex-direction: column;
`;

export const Buttons = styled(Box)`
  text-align: right;
`;

export const RequestRatingButton = styled(AnchorButton)`
  .small {
    display: none;
  }

  svg {
    fill: #fff;
    margin-left: 5px;
  }

  &:hover {
    svg {
      fill: #000;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .small {
      display: block;
    }

    .big {
      display: none;
    }

    svg {
      display: none;
    }
  }
`;

export const ButtonReadReport = styled(AnchorButton)`
  @media (max-width: ${breakpoints.sm}) {
    display: block;
  }
`;

export const Score = styled(Box)`
  h4 {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1;
  }

  span {
    font-weight: 700;
    font-size: 2rem;
  }
`;

export const Rating = styled.h3<{ rating: string }>`
  font-size: 4.4rem;
  font-weight: 700;
  line-height: 1;

  span {
    font-weight: 500;
    font-size: 1.6rem;
    margin-left: 10px;
  }

  ${({ rating }) =>
    rating.indexOf('A') > -1 &&
    css`
      color: #4fa655;
    `}

  ${({ rating }) =>
    rating.indexOf('B') > -1 &&
    css`
      color: #3db6b8;
    `}

  ${({ rating }) =>
    rating.indexOf('C') > -1 &&
    css`
      color: #ebc970;
    `}

  ${({ rating }) =>
    rating.indexOf('D') > -1 &&
    css`
      color: #ee7165;
    `}
`;

export const PoweredBy = styled.div`
  margin-top: 5px;
  margin-bottom: -10px;
  text-align: right;

  a {
    font-size: 1.2rem;
    text-decoration: none;
    display: inline-block;
    opacity: 0.4;
    color: #fff;

    &:hover {
      opacity: 0.5;
    }
  }
`;
